module.exports = __webpack_public_path__ + "img/pvc_360g_farbauswahl_komplett.578655b0.jpg";